import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { useReporter } from '../../../reporter';
import { useOffer } from '../../../offer';
import { headerBannerClicked } from './events';
import { StyledDiscountBanner, OfferBannerText, OfferLink } from './styles';

export const DiscountBanner = ({ sticky = false }) => {
  const { message } = useOffer();
  const link = message
    ? {
        text: 'Try now!',
        target: '/onboarding/',
      }
    : null;
  const reporter = useReporter();
  const trackEvent = headerBannerClicked(message, link);
  return (
    <StyledDiscountBanner sticky={sticky}>
      {message && <OfferBannerText>{message}</OfferBannerText>}
      {link && (
        <Link href={link.target} passHref>
          <OfferLink onClick={() => reporter.tag(trackEvent)}>
            <OfferBannerText>{link.text}</OfferBannerText>
          </OfferLink>
        </Link>
      )}
    </StyledDiscountBanner>
  );
};

DiscountBanner.displayName = 'DiscountBanner';

DiscountBanner.propTypes = {
  sticky: PropTypes.bool,
};
